module.exports = __webpack_public_path__ + "img/OverseaMember34.7372eff8.jpg";